import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "@/contexts/CartContext";
import { Star } from "lucide-react";

export default function ProductCard({ product }) {
  const { add } = useCart();
  const price = product.sale_price || product.price;
  const hasSale = !!product.sale_price;
  return (
    <div data-testid={`product-card-${product.slug}`} className="product-card group">
      <Link to={`/product/${product.slug}`} className="block">
        <div className="relative aspect-[4/5] overflow-hidden bg-[#1a1a1a]">
          {product.images?.[0] && (
            <img src={product.images[0]} alt={product.name} className="w-full h-full object-cover" loading="lazy" />
          )}
          <div className="absolute top-4 left-4 flex flex-col gap-2">
            {product.new_arrival && <span className="badge-emerald">New</span>}
            {hasSale && <span className="badge-gold">Sale</span>}
          </div>
        </div>
      </Link>
      <div className="p-5">
        <div className="text-xs tracking-widest uppercase text-gray-500 mb-1">{product.category_slug?.replace(/-/g, " ")}</div>
        <Link to={`/product/${product.slug}`} className="font-display text-lg font-medium text-white hover:text-[#D4AF37] transition line-clamp-1">{product.name}</Link>
        <div className="flex items-center justify-between mt-3">
          <div className="flex items-baseline gap-2">
            <span className="text-[#D4AF37] font-semibold">${price.toFixed(2)}</span>
            {hasSale && <span className="text-gray-500 text-sm line-through">${product.price.toFixed(2)}</span>}
          </div>
          <button
            data-testid={`add-to-cart-${product.slug}`}
            onClick={(e) => { e.preventDefault(); add(product); }}
            className="text-xs tracking-widest uppercase text-white hover:text-[#D4AF37] transition"
          >
            Add +
          </button>
        </div>
      </div>
    </div>
  );
}
